import { useT, useLanguage } from "@/context/LanguageContext";
import { translations } from "@/data/translations";
import { Link } from "react-router-dom";

export default function Footer() {
  const t = useT(translations.footer);
  const navT = useT(translations.nav);
  const { lang } = useLanguage();

  const navLinks = [
    { key: "features", href: "#features" },
    { key: "disciplines", href: "#disciplines" },
    { key: "screenshots", href: "#screenshots" },
    { key: "pricing", href: "#pricing" },
    { key: "faq", href: "#faq" },
  ];

  return (
    <footer
      data-testid="footer"
      className="relative bg-[#1a1f26] border-t border-white/5"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <a
              href="#hero"
              className="font-bold text-xl tracking-tight text-white inline-block mb-4"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              MMA<span className="text-[#b87b56]">TIMER</span>
            </a>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              {t.tagline}
            </p>
          </div>

          {/* Sections */}
          <div>
            <h4
              className="text-sm font-bold text-white uppercase tracking-widest mb-4"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.sections}
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.key}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.key}`}
                    className="text-sm text-slate-400 hover:text-[#b87b56] transition-colors"
                  >
                    {navT[link.key]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4
              className="text-sm font-bold text-white uppercase tracking-widest mb-4"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.legal}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacidad"
                  data-testid="footer-link-privacy"
                  className="text-sm text-slate-400 hover:text-[#b87b56] transition-colors"
                >
                  {t.privacy}
                </Link>
              </li>
              <li>
                <Link
                  to="/terminos"
                  data-testid="footer-link-terms"
                  className="text-sm text-slate-400 hover:text-[#b87b56] transition-colors"
                >
                  {t.terms}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} MMA Timer. {t.rights}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-slate-500 uppercase tracking-wider">
              {lang === "es" ? "Hecho para peleadores" : "Built for fighters"}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
